import Deposit from "../containers/Account/Deposit";
import DepositDetails from "../containers/Account/DepositDetails";
import SportsPrematch from "../containers/Sports/SportsPrematch";
import SportsLive from "../containers/Sports/SportsLive";
import Esports from "../containers/Sports/Esports";
import Casino from "../containers/Slot/Casino";
import Main from "../containers/Sports/Main";
// Account Start 
import WithDrawal from '../containers/Account/Withdrawal';
import WithdrawalDetails from '../containers/Account/WithdrawalDetails';
import ExChange from '../containers/Account/ExChange';
import Point from '../containers/Account/Point';
import MyPage from '../containers/Account/MyPage';
import Histories from '../containers/Account/Histories';
import Attendance from '../containers/Account/Attendance';
import Notices from '../containers/Account/Notices';
import Messages from '../containers/Account/Messages';
import Inquiries from '../containers/Account/Inquiries';
import Recommender from '../containers/Account/Recommender';
import Setting from '../containers/Account/Setting';
import Minigame from "../containers/minigame/MiniGame";
import E_Event from "../containers/E_Event";
import BetGame from "../containers/BetGame/BetGame";
import Slot from "../containers/Slot/Slot";
import EOSPowerball from "../containers/minigame/EOSPowerball";
import HighLow from "../containers/minigame/HighLow";
import TokenRoulette from "../containers/minigame/TokenRoulette";
import PowerballEvo from "../containers/minigame/PowerballEvo";
import Nuguri from "../containers/minigame/Nuguri";
import Soccer from "../containers/minigame/Soccer";
import Baseball from "../containers/minigame/Baseball";
import Squidgame from "../containers/minigame/Squidgame";
import Login from "../components/Layout/Login";
import Register from "../components/Layout/Register";
import Lottery from "../containers/Account/Lottery";
import Coupon from "../containers/Account/Coupon";
import Roulette from "../containers/Account/Roulette";

const routes = [
    {
      pathname: '/',
      component: Main,
      exact: true,
      isPublic: true,
    },
    {
      pathname: '/login',
      component: Login,
      exact: true,
      isPublic: true
    },
    {
      pathname: '/register',
      component: Register,
      exact: true,
      isPublic: true
    },
    {
      pathname: '/deposit',
      component: Deposit,
      exact: true,
    },
    {
      pathname: '/mypage',
      component: MyPage,
      exact: false,
    },
    {
      pathname: '/deposit/details',
      component: DepositDetails,
      exact: true,
    },
    // {
    //   pathname: '/sportsprematch',
    //   component: SportsPrematch,
    //   exact: true,
    //   value: "sport_prematch"
    // },
    // {
    //   pathname: '/sportslive',
    //   component: SportsLive,
    //   exact: true,
    //   value: "sport_live"
    // },
    // {
    //   pathname: '/esports',
    //   component: Esports,
    //   exact: true,
    //   value: "esport_prematch"
    // },
    
    {
      pathname: '/casino',
      component: Casino,
      exact: false,
      value: "casino"
    },
    {
      pathname: '/hotelcasino',
      component: ()=>Casino({hotel:true}),
      exact: false,
    },
    {
      pathname: '/slot',
      component: Slot,
      exact: false,
      value: "slot"
    },
    // {
    //   pathname: '/minigame',
    //   component: Minigame,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/eospowerball',
    //   component: EOSPowerball,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/highlow',
    //   component: HighLow,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/roulette',
    //   component: Roulette,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/powerball_evo',
    //   component: PowerballEvo,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/nuguri',
    //   component: Nuguri,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/soccer',
    //   component: Soccer,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/baseball',
    //   component: Baseball,
    //   exact: true,
    //   value: "minigame"
    // },
    // {
    //   pathname: '/minigame/squidgame',
    //   component: Squidgame,
    //   exact: true,
    //   value: "minigame"
    // },
    {
      pathname: '/events',
      component: E_Event,
      exact: true
    },
    // {
    //   pathname: '/betgame',
    //   component: BetGame,
    //   exact: false,
    //   value: "betgame"
    // },
    {
      pathname: '/withdraw',
      component: WithDrawal,
      exact: true
    },
    {
      pathname: '/withdraw/details',
      component: WithdrawalDetails,
      exact: true
    },
    {
      pathname: '/exchange',
      component: ExChange,
      exact: true
    },
    
    {
      pathname: '/point',
      component: Point,
      exact: true
    },
    {
      pathname: '/histories',
      component: Histories,
      exact: true
    },
    // {
    //   pathname: '/attendance',
    //   component: Attendance,
    //   exact: true
    // },

    {
      pathname: '/notices',
      component: Notices,
      exact: true
    },

    {
      pathname: '/messages',
      component: Messages,
      exact: true
    },

    {
      pathname: '/inquiries',
      component: Inquiries,
      exact: false
    },

    {
      pathname: '/recommender',
      component: Recommender,
      exact: true
    },

    {
      pathname: '/setting',
      component: Setting,
      exact: true
    },
    
    {
      pathname: '/attendance',
      component: Attendance,
      exact: true
    },

    {
      pathname: '/lottery',
      component: Lottery,
      exact: true
    },

    {
      pathname: '/coupon',
      component: Coupon,
      exact: true
    },

    {
      pathname: '/roulette',
      component: Roulette,
      exact: true
    },
]

export default routes;


// WEBPACK FOOTER //
// ./src/routes/index.js